export class LoginParamModel {
  api: string;
  idEmpresa: string;
  email: string;
  cliente: string;
  senha: string;
  novaSenha: string;
  cpf: string;
}
